// src/components/SystemRecommendation/components/CollapsibleSection.tsx

import React, { useState } from 'react';
import { ConfidenceLevel } from '../types';

interface CollapsibleSectionProps {
  title: string;
  icon: string;
  confidenceLevel: ConfidenceLevel;
  summary: string;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  icon,
  confidenceLevel,
  summary,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getConfidenceColor = (level: ConfidenceLevel) => {
    switch (level) {
      case 'high':
        return '#10b981'; // Green
      case 'medium':
        return '#f59e0b'; // Amber
      case 'low':
        return '#ef4444'; // Red
    }
  };

  const getConfidenceLabel = (level: ConfidenceLevel) => {
    switch (level) {
      case 'high':
        return 'High Confidence';
      case 'medium':
        return 'Medium Confidence';
      case 'low':
        return 'Needs Verification';
    }
  };

  return (
    <div className="collapsible-section">
      <button
        className={`section-header ${isExpanded ? 'expanded' : ''}`}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <div className="section-header-content">
          <span className="section-icon">{icon}</span>
          <div className="section-title-group">
            <h3 className="section-title">{title}</h3>
            <p className="section-summary">{summary}</p>
          </div>
        </div>
        <div className="section-header-right">
          <span
            className="confidence-indicator"
            style={{ backgroundColor: getConfidenceColor(confidenceLevel) }}
            title={getConfidenceLabel(confidenceLevel)}
          >
            {getConfidenceLabel(confidenceLevel)}
          </span>
          <span className="expand-icon">{isExpanded ? '−' : '+'}</span>
        </div>
      </button>

      {isExpanded && (
        <div className="section-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
